import type { GetReferralPopupByPartnerKeyResponse } from '@/open-api/model/getReferralPopupByPartnerKeyResponse';

import type { ReferredVisitorPopupContent } from './types';

export const mapReferralPopupContent = (
  data: GetReferralPopupByPartnerKeyResponse | undefined
): ReferredVisitorPopupContent | null => {
  const creatorName = data?.creatorName?.trim();

  if (!(data && creatorName)) {
    return null;
  }

  return {
    creatorName,
    imageUrl: data.imageUrl || null,
    hasDiscount: data.hasDiscount,
    discountPercentage: data.discountPercentage ?? null,
    customSubjectLine:
      (data.hasCustomText && data.customSubjectLine?.trim()) || null,
    customMainText: (data.hasCustomText && data.customMainText?.trim()) || null,
    showBenefits: data.showBenefits === true,
  };
};

/** Benefits stand in for the price comparison, so never show both. */
export const shouldShowBenefits = (
  content: ReferredVisitorPopupContent
): boolean => content.showBenefits && getAdvertisedDiscount(content) === null;

/**
 * The discount to advertise, or null when the no-discount copy should be used
 * (discount turned off, or switched on without a usable percentage).
 */
export const getAdvertisedDiscount = (
  content: ReferredVisitorPopupContent
): number | null => {
  const { hasDiscount, discountPercentage } = content;

  if (!hasDiscount || discountPercentage === null || discountPercentage <= 0) {
    return null;
  }

  return discountPercentage;
};

// VIP creators (set up in Conductor) get the personalised pop-up; everyone
// else falls through to the generic coupon pop-up
export const shouldShowCreatorPopup = ({
  content,
  isEligible,
}: {
  content: ReferredVisitorPopupContent | null;
  isEligible: boolean;
}): boolean => content !== null && isEligible;
